import React from 'react'

export function Counter({ value, maxLength }) {
  const remainingChars = value ? maxLength - value.length : maxLength

  return (
    <p className="mt-4 self-end text-sm text-[#5d5d5d]">
      Characters remaining: {remainingChars}
    </p>
  )
}
